import { memo, useCallback, useMemo } from 'react';
import cn from 'classnames';
import { twMerge } from 'tailwind-merge';
import { ALIGN_TYPE } from '@zmedia/bm-soccer-ui/constants';
import { IContent, IContentItemClass } from '@zmedia/bm-soccer-ui/interface';
import { Element, List } from '@zmedia/bm-soccer-ui/components';
import { ContentItem as _ContentItem } from '../item';
import styles from './style.module.scss';

interface IProps {
    items: IContent[];
    children?: React.ReactNode;
    align?: ALIGN_TYPE;
    alignItem?: ALIGN_TYPE;
    showSapo?: boolean;
    showFullThumb?: boolean;
    ContentItemClass?: IContentItemClass;
    ContentItemProps?: any;
    ContentItem?: any;
    EventSection?: any;
}
function ContentList({
    items = [],
    children,
    alignItem,
    showSapo,
    showFullThumb = false,
    ContentItemClass = {
        CardHeaderClass: '',
    },
    ContentItemProps = {},
    ContentItem,
    EventSection,
}: IProps) {
    const getClassName = useMemo(() => {
        const { CardClass, CardHeaderClass, CardImageClass, CardContentClass } =
            ContentItemClass;

        const _ContentItemClass = Object.assign({}, ContentItemClass, {
            CardClass: twMerge(
                cn(
                    'flex w-full'
                    // '[&:not(:first-child)]:mt-[15px] [&:not(:first-child)]:pt-[11px]',
                    // '[&:not(:first-child)]:border-t [&:not(:first-child)]:border-solid [&:not(:first-child)]:border-[#e9ecef]'
                ),
                CardClass
            ),
            CardHeaderClass: twMerge(
                'text-[2.5rem] xs:text-[2.2rem] leading-[1.45]',
                CardHeaderClass
            ),
            CardImageClass: twMerge('w-[226px]', CardImageClass),
            CardContentClass: twMerge('ml-[15px]', CardContentClass),
        });

        return _ContentItemClass;
    }, [ContentItemClass]);

    const renderItem = (item: IContent, index: number) => {
        if (!ContentItem) {
            return null;
        }
        const ContentItemComponent = ContentItem ? ContentItem : null;
        item.contentId = item.id;
        item.date = item.publishedDate || 0;
        item.tracking = '|soccer';
        item.thumb = showFullThumb ? item.thumbM : item.thumb;
        const lazyloadImage = index > 2;
        const _ContentItemClass = getClassName;

        if (index === 3 && EventSection) {
            return (
                <EventSection
                    className="mb-[12px] pb-[12px] border-b border-solid border-[#e9ecef] w-full"
                    categoryId="1336"
                    key={'event'}
                />
            );
        }

        return (
            <ContentItemComponent
                key={index}
                item={item}
                align={alignItem}
                tracking={`|soccer|index${index}`}
                showSapo={showSapo}
                lazyloadImage={lazyloadImage}
                className={styles['soccer-content-item']}
                ContentItemClass={_ContentItemClass}
                {...ContentItemProps}
            />
        );
    };

    const renderItems = useCallback(() => {
        return items.map((item, index) => {
            return renderItem(item, index);
        });
    }, [items]);

    return <List>{children ? children : renderItems()} </List>;
}

export default memo(ContentList);

// export default dynamic(() => Promise.resolve(ContentList), {
//     ssr: false,
// });
